<!--
 * @Description: 
 * @version: 
 * @Author: m
 * @LastEditors: m
-->
<template>
	<div>
		<van-form>
			<van-field v-model="form.process_name" label="流程" readonly />
			<van-field v-model="form.xmmc" label="项目名称" readonly />
			<van-field v-model="form.hxsj" label="花销时间" readonly />
			<van-field v-model="bxlxList[form.bxlx]" name="报销类型" label="报销类型" readonly />
			<van-field v-model="form.bxsm" label="报销说明" readonly />
			<van-field v-model="form.je" label="金额" readonly />
			<div class="schedule" v-if="form.file_list != null">
				<p>附件列表</p>
				<div class="schedule-body">
					<div class="file-body">
						<div class="file-body-item" v-for="(item, index) in form.file_list" :key="index">
							<div class="img-body" v-if="isTypeImage(item.file_type)">
								<van-image width="100" height="100" :src="fileUrl + item.file_id"
									@click="imgLook(fileUrl + item.file_id)" />
							</div>
							<div class="img-body" v-else-if="isTypeMp4(item.file_type)"
								@click="lookVideo(fileUrl + item.file_id)">
								<i class="file-icon van-icon-description"></i>
								<div class="file-name">{{ item.file_name }}</div>
							</div>
							<div class="img-body" v-else-if="isType(item.file_type)"
								@click="lookfile(fileUrl + item.file_id)">
								<i class="file-icon van-icon-description"></i>
								<div class="file-name">{{ item.file_name }}</div>
							</div>
							<div class="img-body" v-else @click="clickFile">
								<i class="file-icon van-icon-description"></i>
								<div class="file-name">
									{{ item.file_name }}.{{ item.file_type }}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</van-form>
		<van-popup v-model="videoShow" style="width: 100%" @close="closePanel">
			<video-player id="video" class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true"
				:options="playerOptions"></video-player>
		</van-popup>
		<van-popup v-model="showPopup" style="width: 100%;height: 80%;" @opened="pdfpanel">
			<div class="m-pdf" >
				<div id="pdf-content"></div>
			</div>
		</van-popup>
	</div>
</template>

<script>
import { Toast } from "vant";
import global_url from "@/utils/global";
import { isImage, isMp4, istype } from "@/utils/tool";
import { ImagePreview } from "vant";
import Pdfh5 from "pdfh5";
import "pdfh5/css/pdfh5.css";
export default {
	name: "purchase",
	props: {
		rform: Object
	},
	data() {
		return {
			fileUrl: this.findUrl(),
			playerOptions: {
				autoplay: false,
				muted: false,
				preload: "auto",
				language: "zh-CN",
				aspectRatio: "16:9",
				fluid: true,
				sources: [
					{
						type: "video/mp4",
						src: "",
					},
				],
				notSupportedMessage: "此视频暂无法播放，请稍后再试",
				controlBar: {
					timeDivider: true,
					durationDisplay: true,
					remainingTimeDisplay: false,
				},
			},
			form: {
				xmmc: "",
				hxsj: "",
				bxsm: "",
				bxlx: "",
				je: ""
			},
			videoShow: false,
			showPopup: false,
			pdfUrl: "",
			bxlxList: ["交通", "住宿", "餐饮", "其他"]
		};
	},
	watch: {
		rform: {
			immediate: true,
			handler(newV) {
				this.form = newV;
			}
		}
	},
	methods: {
		closePanel() {
			let video = document.getElementsByTagName("video")[0];
			video.pause();
		},
		lookVideo(url) {
			console.log(url);
			this.playerOptions.sources[0].src = url;
			this.videoShow = true;
		},
		pdfpanel() {
			//先实例化
			this.pdfh5 = new Pdfh5("#pdf-content", {
				pdfurl: this.pdfUrl,
				goto: 1,
				lazy: true,
			});
			this.pdfh5.scrollEnable(true); 
		},
		lookfile(row) {
			this.showPopup = true;
			this.pdfUrl = row
			// console.log(row);

		},
		isTypeMp4(name) {
			return isMp4(name);
		},
		isType(name) {
			return istype(name);
		},
		isTypeImage(name) {
			return isImage(name);
		},
		findUrl() {
			return global_url.fileUrl;
		},
		imgLook(url) {
			ImagePreview({
				images: [url],
			});
		},
		clickFile() {
			return Toast.fail("暂不支持该文件查看");
		},
	}
};
</script>

<style lang="less" scoped>
.m-pdf {
	// 保证pdf区域铺满整个屏幕
	// 方法1：使用vw和vh视窗单位，1vw=视窗宽度的1%；1vh=视窗高度的1%
	// width: 100vw;
	// height: 100vh;
	// 方法2：使用fixed定位
	position: fixed;
	top: 0;
	bottom: 0;
	right: 0;
	left: 0;
}

.file-body {
	width: calc(100% + 10px);
	padding: 0;
	display: flex;
	flex-wrap: wrap;

	.file-body-item {
		list-style: none;
		flex: 0 0 calc(33.33% - 10px);
		margin-right: 10px;
	}
}

.schedule {
	margin-top: 1px;
	margin-bottom: 12px;
	// padding-left:15px;
	margin-left: 20px;
	margin-right: 20px;

	// overflow: hidden;
	.file-body {
		display: -webkit-box;
		display: -webkit-flex;
		display: flex;
		-webkit-flex-wrap: wrap;
		flex-wrap: wrap;
		margin-top: 2px;

		&-item {
			position: relative;
			margin: 0 2px 2px 0;
			cursor: pointer;

			.img-body {
				display: block;
				width: 80px;
				height: 80px;
				overflow: hidden;
				border-radius: 8px;
				box-shadow: #ebedf0 0 4px 12px;
				text-align: center;

				img {
					object-fit: cover;
					display: block;
					width: 100%;
					height: 100%;
				}

				.file-icon {
					position: relative;
					display: inline-block;
					font: normal normal normal 14px/1 "vant-icon";
					font-size: inherit;
					text-rendering: auto;
					-webkit-font-smoothing: antialiased;
					color: #646566;
					font-size: 20px;
					margin-top: 15px;
				}

				.file-name {
					box-sizing: border-box;
					width: 100%;
					margin-top: 4px;
					padding: 0 4px;
					color: #646566;
					font-size: 12px;
					text-align: center;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 3;
					overflow: hidden;
				}
			}
		}
	}
}
</style>